import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useMoteListenActivityMutation = ({ moteId }) => {
  const values = useGenericRequestHandler({
    route: `a/listen/${moteId}`,
    method: 'POST'
  })
  return withEngagingURL(values)
}
